export default "__VITE_ASSET__CaEEZEUV__"